$(document).ready(function(){
  
  		$(".swatch-element.color:nth-child(2)").addClass("active");
  		var textValue_first = $(".swatch-element.color:nth-child(2) input[type=radio]").val();
   		var textsecValue = $("#featuted-image .img-zoom.img-responsive").attr("alt");
  		if (! textValue_first == "") {
          $("#gallery_main .image-thumb img").closest("div").css("display", "none");
          $("#gallery_main .image-thumb img[alt="+textsecValue+"]").closest("div").addClass("active_test").css("display", "block");
        }
  		
  		$(".swatch-element.color input[type=radio]").click(function(){
        	var textValue = $(this).val()
            $("#gallery_main .image-thumb img").closest("div").css("display", "block");
        	$("#gallery_main .image-thumb img").closest("div.owl-item").css("display", "none");
			$("#gallery_main .image-thumb img[alt="+textValue+"]").closest("div.owl-item").css("display", "block");

		});
  
  		$( ".swatch-element.soldout" ).remove();

})


